const content = {
  data: {}
}

export default content
